package ru.villawonka.app.platform

class JsLogger : Logger {

    override fun log(message: String) {
        console.log(message)
    }
}